const ActionBar = ({ children }) => {
  return (
    <div class="action-bar" style={{ padding: "15px 14px" }}>
      {children}
    </div>
  );
};
export default ActionBar;



// WEBPACK FOOTER //
// ./components/ActionBar.js